import { useEffect } from 'react';
import { getAreAgentsAvailable, getLiveChatAnchor, getLiveChatButton } from 'lib/liveChat';
import { CONTACT_US_URL } from 'config/constants';
import { trackLiveChatClick } from './trackLiveChatClick';

export const useLiveChatClickHandler = () => {
  useEffect(() => {
    const liveChatAnchorEl = getLiveChatAnchor();

    liveChatAnchorEl?.addEventListener('click', handleLiveChatClickEvent);

    return () => liveChatAnchorEl?.removeEventListener('click', handleLiveChatClickEvent);
  }, []);
};

function handleLiveChatClickEvent(event: MouseEvent) {
  // ignore if not a click on the button
  if (!getLiveChatButton()?.contains(event.target as Node)) return;

  trackLiveChatClick(event);

  if (!getAreAgentsAvailable()) {
    window.open(CONTACT_US_URL, '_blank');
  }
}
